'use strict';

var KHOROS = {
     lazyloadResources: {
          init: function() {
               var lazyLoadInstance = new LazyLoad({
                    // Your custom settings go here
               });
          }
     },
     elementToggles: {
          init: function() {
              this.setUpEvents();
          },
          setUpEvents: function() {
              $('body').on('click', '[data-toggle]', function(){
                  $($(this).data('toggle')).toggle();
  
                  //custom events
                  var targetSelector = $(this).data('toggle');
  
                  if (targetSelector == '#globalSearchForm') {
                      $('#globalSearchForm input').focus();
                  }
              });
          }
      },
     mobileMenu: {
          init: function() {
              this.setUpEvents();
          },
          setUpEvents: function() {
              $('body').on('click', '[data-mobile-menu-toggle]', function(){
                  $(this).closest('li').toggleClass('active');
              });
          }
     },
     marketoForms: {
          init: function() {   
            var formIds = [];

            $('form[id*="mktoForm"]').each(function(){
                formIds.push($(this).attr('id').replace('mktoForm_',''));
            });

            var mktoFormConfig = {
                podId : "//pages.khoros.com",
                munchkinId : "104-HTZ-433",
                formIds : formIds
            };

            var invalidDomains = [
                "@1und1.",
                "@aol.",
                "@earthlink.",
                "@email.",
                "@freenet.",
                "@gemail.",
                "@gmail.",
                "@gmx.",
                "@googlemail.",
                "@hotmail.",
                "@icloud.",
                "@laposte.net",
                "@live.",
                "@mail.",
                "@me.",
                "@msn.",
                "@outlook.",
                "@test.",
                "@wanadoo.",
                "@web.",
                "@yahoo.",
                "@ymail."
            ];

            function isEmailGood(email) {
                for(var i=0; i < invalidDomains.length; i++) {
                    var domain = invalidDomains[i];
                    if (email.indexOf(domain) != -1) {
                        return false;
                    }
                }

                return true;
            }

             // Define the field mapping: UTM parameter -> Marketo field name
            var fieldMapping = {
                utm_source: 'Most_Recent_utm_Source__c',
                utm_medium: 'Most_Recent_utm_Medium__c',
                utm_campaign: 'Most_Recent_utm_Campaign__c',
                utm_term: 'Most_Recent_utm_Term__c',
                utm_content: 'Most_Recent_utm_Content__c'
            };

            // Function to parse UTM parameters from URL
            function getUTMParams() {
                var params = {};
                var queryString = window.location.search.substring(1); // Remove the '?'
                var pairs = queryString.split("&");
                for (var i = 0; i < pairs.length; i++) {
                    var pair = pairs[i].split("=");
                    if (pair.length === 2) {
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        params[key] = value;
                    }
                }
                return params;
            }

            // Retrieve UTM parameters from the URL
            var utmParams = getUTMParams();

            // Initialize hiddenFields object
            var hiddenFields = {};

            // Marketo Forms 2.0 API: whenReady callback
            MktoForms2.whenReady(function(form) {
                var formId = form.getId(); // Get the current form's ID

                // Iterate over each key in fieldMapping
                var keys = Object.keys(fieldMapping);
                for (var i = 0; i < keys.length; i++) {
                    var utmKey = keys[i];
                    var marketoField = fieldMapping[utmKey];
                    if (utmParams[utmKey]) {
                        hiddenFields[marketoField] = utmParams[utmKey];
                    }
                }

                // Check if there are any hidden fields to add
                if (Object.keys(hiddenFields).length > 0) {
                    form.addHiddenFields(hiddenFields);
                } else {
                    console.log('No UTM parameters found to add as hidden fields.');
                }
            });


            formIds.forEach(function(id){
                // load form
                MktoForms2.loadForm(mktoFormConfig.podId, mktoFormConfig.munchkinId, id, function(form){
                    var $form = form.getFormElem();
                    var ctaText = $form.data('cta-text');

                    if(ctaText){
                        $form.find('button[type=submit]')
                            .text(ctaText);
                    }
                    form.onValidate(function(){
                      var email = form.vals().Email;

                      if (typeof email == "undefined" || isEmailGood(email)) {
                          form.submitable(true);
                      }
                      else {
                          form.submitable(false);

                          var emailElem = $('#mktoForm_' + form.getId() + ' [name=Email]');

                          form.showErrorMessage("Please provide a valid business email address.", emailElem);
                      }
                    }); 

                    form.onSuccess(function(values, returnUrl) {
                      var $form = form.getFormElem();

                      var newUrl = $form.data('return-url');

                      if (newUrl) {
                          window.location.href = newUrl;
                      }
                      else {
                          $form.find('button[type=submit]')
                              .text('Thank you!')
                              .attr('disabled','disabled');
                          $form.find('input').attr('disabled','disabled');
                      }

                      return false; 
                    });
                });  
            }); 
          }
     },
     helloBar: {
        init: function(){
            var that = this;
            var $helloBar = $('.helloBar');
            var cookieName = $helloBar.data('cookie-name');
            var cookie = Cookies.get(cookieName);

            if (cookie === undefined && $helloBar.length) {
                $helloBar.find('[data-close]').on('click', function(){
                    that.dismissBar()
                });

                that.toggle();
            }
        },
        toggle: function(){
            var $helloBar = $('.helloBar');
            $helloBar.toggle();
        },
        dismissBar: function(){
            this.toggle();

            var $helloBar = $('.helloBar');
            var cookieName = $helloBar.data('cookie-name');

            Cookies.set(cookieName, '1');
        }
    },   
    youTubeVideos: {
      init: function(){

        $('iframe').each(function() {
            var $iframe = $(this);
            var src = $iframe.attr('src');

            if (src && src.startsWith('https://www.youtube.com/embed/')) {
                $iframe.addClass('youtube-video');
            }
        });
      }
    }  
}

$(function(){
     KHOROS.lazyloadResources.init();
     KHOROS.helloBar.init();
     KHOROS.elementToggles.init();
     KHOROS.mobileMenu.init();
     KHOROS.marketoForms.init();
     KHOROS.youTubeVideos.init();
});